module.exports = __webpack_public_path__ + "static/media/projects.efec0bd7.svg";